<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.ElectronicBoxListSendingHistory')"
    width="700px"
    :close-on-click-modal="false"
    class="app-main-inner econtainer-history"
  >
    <div class="app-main-inner-row row-grid-dialog" style="padding-top: 0;">

      <cargo-ag-grid
        :show-side-bar="false"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
      />
    </div>
  </el-dialog>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export default {
  name: 'EcontainerHistory',
  props: {
    visible: { type: Boolean, required: true },
    params: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: false,
      rowData: [],
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false
      },
      columnDefs: [
        {
          headerName: this.$t('Payment.businessNumber'),
          field: 'jobNo',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.Cargo_SendDate'),
          field: 'dateCreated',
          width: 140
        }, {
          headerName: this.$t('Payment.operator'),
          field: 'createdBy',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.PrintTime'),
          field: 'printDate',
          width: 140
        }, {
          headerName: this.$t('SeaExport.PrintingTimes'),
          field: 'printCount',
          width: 80
        }, {
          headerName: this.$t('Partners.isItSuccessful'),
          field: 'success',
          width: 80,
          cellRenderer: (params) => {
            return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
          }
        }
      ]
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
      this.rowData = this.params.data
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  }
}
</script>

<style lang="scss">
.econtainer-history {
  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>
